import { createStore } from "@ttoohey/react-redux-modules";
import { routerMiddleware } from "react-router-redux";
export default history =>
  createStore(
    {
      default: (state = null, action) => state
    },
    [routerMiddleware(history)]
  );



// WEBPACK FOOTER //
// ./src/services/store/createStore.js